// 地图API加载完成事件
export const MAP_API_LOADED = 'onMapAPILoaded'

// 地图创建完毕的事件名称
export const MAP_CREATED = 'onMapCreated'

// 准备销毁地图的事件名称
export const MAP_DESTROY = 'onMapDestroy'

// 切换地图图层
export const MAP_TILES_CHANGED = 'onMapTilesChanged'

// 改变显示卫星地图状态的事件名称
export const SATELLITE_MODE_CHANGE = 'onSatelliteModeChange'

// 地图风格变化的事件
export const MAP_STYLE_CHANGED = 'onMapStyleChanged'

// 获取地图接口的事件名称
export const GET_MAP = 'onGetMap'

// 获取全局地图对象的事件名称
export const GET_MAP_API = 'onGetMapAPI'

// 地图鼠标移动的事件名称
export const MAP_MOUSE_MOVE = 'onMapMouseMove'

// 地图鼠标点击的事件名称
export const MAP_CLICK = 'onMapClick'

// 地图鼠标右击事件名称
export const MAP_MOUSE_RIGHT_CLICK = 'onMapMouseRightClick'

// 地图双击事件
export const MAP_DB_CLICK = 'onMapDBClick'

export const MAP_ZOOM = 'onMapZoom'

// 地图视野变化结事时的事件
export const MAP_ZOOM_END = 'onMapZoomEnd'

export const MAP_MOVE_START = 'onMapMoveStart'

export const MAP_MOVE = 'onMapMove'

export const MAP_MOVE_END = 'onMapMoveEnd'

export const MAP_REMOVE_OVERLAY = 'onMapRemoveOverlay'

export const MAP_CENTER_CHANGE = 'onMapCenterChange'

export const MAP_ZOOM_CHANGE = 'onMapZoomChange'

export const MAP_FIT_VIEW_CHANGE = 'onMapFitViewChange'

export const MAP_CLEAR = 'onMapClear'

// 根据点设置地图视野
export const SET_MAP_CENTER_BY_POINTS = 'onSetMapCenterByPoints'

// 最佳视角发生变化的事件名
export const BEST_VIEW_CHANGED = 'onBestViewChanged'

// 设置最佳视角
export const SET_BEST_VIEW = 'onSetBestView'



// WEBPACK FOOTER //
// ./src/components/Map/EventKeys.js